import StripeWrapper from "./stripeWrapper.container";

export default StripeWrapper;
